import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/api.service';
import { NbToastrService, NbDialogRef } from '@nebular/theme';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-setting-network',
  templateUrl: './setting-network.component.html',
  styleUrls: ['./setting-network.component.scss']
})
export class SettingNetworkComponent implements OnInit {
  facebook;
  youtube;
  twitter;
  instagram;
  linkedin;
  viadeo;
  pinterest;
  hideLoader = true;
  hideButon;
  @ViewChild('userRegistrationForm',{static:true}) myForm; 
  constructor(protected dialogRef: NbDialogRef<SettingNetworkComponent>,private apiservice:ApiService,public toastr:NbToastrService, private router: Router) { }

  ngOnInit() {
     this.getNetwork();
  }

  getNetwork(){
    this.apiservice.getParametresNetworkProvider().subscribe((data:any) =>{
      this.instagram = data.instagram;
      this.facebook = data.facebook;
      this.youtube = data.youtube;
      this.linkedin = data.linkedin;
      this.pinterest = data.pinterest;
      this.viadeo = data.viadeo;
      this.twitter = data.twitter;
    })
  }

  cancel(){
    this.dialogRef.close();
  }

  updateNetwork(){
    this.hideLoader = false;
    this.hideButon = true;
    this.apiservice.updateParametresNetworkProvider(this.facebook,this.twitter,this.viadeo,this.pinterest,this.youtube,this.linkedin,this.instagram).subscribe(data =>{
      this.toastr.success("mise à jour réussie","success");
    
    
      // this.myForm.resetForm();
    
      this.hideLoader = true;
      this.hideButon = false;
    },(err) =>{
      console.log(err);
      this.toastr.danger("echec de modification, vérifiez que tous les champs sont bien remplis");
      this.hideLoader = true;
      this.hideButon = false;
      this.toastr.danger("Echec de mise à jour","erreur");
      if(err.error.code ===401){
        localStorage.clear();
        window.location.reload();
        let link2 = ['/login'];
        this.router.navigate(link2);
      }
    })
  }
}
